import React from 'react';

const Mail: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.9882 5.44728C17.9882 5.429 18.0008 5.4112 18 5.39313L13.1173 10.0978L17.9941 14.6522C17.997 14.6197 17.9882 14.5869 17.9882 14.5537V5.44728Z"
      fill="#99A1AB"
    />
    <path
      d="M12.3719 10.8217L10.3787 12.7395C10.2778 12.8365 10.1476 12.8852 10.0172 12.8852C9.88959 12.8852 9.76196 12.8386 9.66179 12.7452L7.67397 10.8929L2.76532 15.6243C2.88468 15.6672 3.01279 15.7005 3.14695 15.7005H16.8875C17.0868 15.7005 17.2736 15.6398 17.4361 15.5493L12.3719 10.8217Z"
      fill="#99A1AB"
    />
    <path
      d="M10.0116 11.6459L17.4632 4.46783C17.2945 4.36752 17.0981 4.30023 16.8877 4.30023H3.14707C2.87297 4.30023 2.62182 4.40666 2.42621 4.56897L10.0116 11.6459Z"
      fill="#99A1AB"
    />
    <path d="M2 5.62207V14.5535C2 14.656 2.02357 14.7549 2.04915 14.8493L6.8969 10.1811L2 5.62207Z" fill="#99A1AB" />
  </svg>
);

export default Mail;
